module.exports = __webpack_public_path__ + "img/MED005.4d57dbdb.png";